// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"244948d8","239":"85ac2057","732":"9d7e2966"}[chunkId] + ".chunk.js";
};